/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useToast } from "@/hooks/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  erp_uom: z.string().min(1, {
    message: "Erp uom is required.",
  }),
  erp_uom_quantity: z.number().min(1, {
    message: "Erp uom quantity is required.",
  }),
  conversion_rate: z.number().min(1, {
    message: "Conversion rate is required.",
  }),
  convert_to: z.string().min(1, {
    message: "convert to is required.",
  }),
  retailer_id: z.string().optional(),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      erp_uom: "",
      conversion_rate: 0,
      erp_uom_quantity: 1,
      convert_to: "",
      retailer_id: "",
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);
    if (data) {
      // toast({
      //   title: "Success",
      //   variant: "success",
      //   description: data.status.msg,
      // });
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
